import React from 'react';
import type { FormRule } from 'antd';
import { DatePicker, Form } from 'antd';
import type { IDataRangeFormPickerProps } from './types';

export const DataRangeFormPicker: React.FC<IDataRangeFormPickerProps> = (props) => {
  const {
    name,
    label,
    isRequired = false,
    className,
    handleSuccess,
    rangePresets,
    disabledDate,
    disabled,
    picker,
  } = props;

  const validationRule: FormRule[] = [
    {
      required: isRequired,
      type: 'array',
    },
  ];

  return (
    <Form.Item name={name} label={label} rootClassName={className} rules={validationRule}>
      <DatePicker.RangePicker
        picker={picker}
        presets={rangePresets}
        allowClear={!isRequired}
        disabledDate={disabledDate}
        disabled={disabled}
        onChange={handleSuccess}
      />
    </Form.Item>
  );
};
